import { render, staticRenderFns } from "./get.vue?vue&type=template&id=9c163a1a"
import script from "./get.vue?vue&type=script&lang=js"
export * from "./get.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports